import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
	Form,
	Button,
	Row,
	Col,
	Card,
	notification,
	Tag,
	Descriptions,
	Space,
	Spin,
	Divider,
} from "antd";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import { getFileNameFromPath, downloadFile } from "../../utils/helper";
import { FormOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import infraChangeRequestService from "../../services/infraChangeRequest";
import approvalService from "../../services/approver";

import CommentSystem from "../../components/comment";
import CreatedByComponent from "../../components/commonDetails/createdBy";
import ApproversComponent from "../../components/commonDetails/approvers";
import ApproveDisapproveComponent from "./../../components/commonDetails/approveDisapprove/index";
import TaskStatus from "../../components/commonDetails/taskStatus";
import { replaceLineBreaks } from "../../utils/helper";
import FeedbackModal from "../../components/feedbackModal";

import qaService from "../../services/qualityAssurance";
import csrfService from "../../services/scrf";
import equipmentRequestService from "../../services/equipmentRequest";
import mobileRequisitionService from "../../services/mobileRequisition";

import mdmService from "../../services/mdm";
import { useSelector } from "react-redux";

import AddApproversComponent from "../../components/commonDetails/manageApprovers";
import { canManageApprovers } from "../../utils/permissions";
import TaskModal from "../../components/taskModal";
import ViewCustomFields from "../../components/viewCustomFields";

const InfraChangeRequestDetails = () => {
	const { currentUser } = useSelector((state) => state.user);
	const navigate = useNavigate();
	const [referenceDoumentTitle, setReferenceDoumentTitle] = useState(null);
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState(null);
	const [data, setData] = useState(null);
	const { id } = useParams();
	const [assignedUserId, setAssignedUserId] = useState(null);
	const [formId] = useState(10);
	const [refresh, setRefresh] = useState(false);
	const [specificReturnGroupId, setSpecificReturnGroupId] = useState([]);
	const hasEditPermission = canManageApprovers(currentUser, "InfraChangeRequestForm");

	// PRINT STYLES & PRINT HANDLER
	useEffect(() => {
		const style = document.createElement("style");
		style.innerHTML = `
      @media print {
        body * {
          visibility: hidden;
        }
        #qqq{
          display:none;
        }
        #ppp, #ppp * {
          visibility: visible;
        }
        #ppp {
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    `;
		document.head.appendChild(style);
		return () => {
			document.head.removeChild(style);
		};
	}, []);

	const [isPrintable, setIsPrintable] = useState(false);
	const handlePrintClick = () => {
		setIsPrintable(true);
		setTimeout(() => {
			window.print();
			setIsPrintable(false);
		}, 100);
	};

	useEffect(() => {
		getInfraChangeRequestDetails();
		setRefresh(false);
	}, [refresh]);



	const getInfraChangeRequestDetails = async () => {
		setLoading(true);
		await infraChangeRequestService
			.getById(id)
			.then((response) => {
				setData(response);
				setLoading(false);
			})
			.catch((error) => {
				console.log("yes error");
				console.log(error);
				// navigate("/deployment");
			});
	};

	const handleSubmit = async (values, isParallel) => {
		setLoading(true);
		const formattedValues = {
			status,
			approved_disapproved: false,
			form_id: formId,
			key: parseInt(id),
			reason: values.message,
			...(isParallel && { assigned_user_id: assignedUserId }),

			...(specificReturnGroupId && Number(specificReturnGroupId) > 0 && {
				approver_id: Number(specificReturnGroupId),
			}),
		};

		const serviceMethod = isParallel
			? approvalService.updateParallelStatus
			: approvalService.updateStatus;

		try {
			const response = await serviceMethod(formattedValues);
			if (response.success) {
				notification.success({
					message: "Status",
					description: response.message,
				});
				form.resetFields();
				getInfraChangeRequestDetails();
			}
			navigate("/dashboard");
		} catch (error) {
			notification.error({
				message: "Error",
				description: error.response?.data?.message || "An error occurred",
			});
		} finally {
			setLoading(false);
		}
	};

	const getQaDetails = async () => {
		await qaService
			.getQaDetails(data.reference_details)
			.then((response) => {
				setReferenceDoumentTitle(response.request_title);
			})
			.catch((error) => {
				console.log("error fetching qa records");
			});
	};
	const getScrfDetails = async () => {
		await csrfService
			.getScrfDetails(data.reference_details)
			.then((response) => {
				setReferenceDoumentTitle(response.request_title);
			})
			.catch((error) => {
				console.log("error fetching scrf records");
			});
	};
	const getEquipmentsRequestById = async () => {
		await equipmentRequestService
			.getEquipmentsRequestById(data.reference_details)
			.then((response) => {
				setReferenceDoumentTitle(response.request_title);
			})
			.catch((error) => {
				console.log("error fetching crf records");
			});
	};
	const getMRDetails = async () => {
		await mobileRequisitionService
			.getMRDetails(data.reference_details)
			.then((response) => {
				setReferenceDoumentTitle(response.request_title);
			})
			.catch((error) => {
				console.log("error fetching mdm records");
			});
	};
	const getMdmDetails = async () => {
		await mdmService
			.getMdmDetails(data.reference_details)
			.then((response) => {
				setReferenceDoumentTitle(response.request_title);
			})
			.catch((error) => {
				console.log("error fetching mdm records");
			});
	};

	const handleRedirect = () => {
		// Define your redirection logic based on form_id
		switch (data.reference_form_id.id) {
			case 1:
				navigate(`/quality-assurance/details/${data.reference_details?.id}`);
				break;
			case 2:
				navigate(`/scrf/details/${data.reference_details?.id}`);
				break;
			case 3:
				navigate(`/deployment/details/${data.reference_details?.id}`);
				window.location.reload();
				// navigate(`/deployment/details/${data.reference_details?.id}`);
				break;
			case 4:
				navigate(`/crf/details/${data.reference_details?.id}`);
				break;
			case 5:
				navigate(`/mobile-requisition/details/${data.reference_details?.id}`);
				break;
			case 6:
				navigate(
					`/master-data-management-form/details/${data.reference_details?.id}`
				);
				break;
			default:
				navigate("/");
		}
	};

	const referenceDocumentTitle = () => {
		// Define your redirection logic based on form_id
		switch (data.form_id.id) {
			case 1:
				getQaDetails();
				break;
			case 2:
				getScrfDetails();
				break;
			case 3:
				getInfraChangeRequestDetails();
				break;
			case 4:
				getEquipmentsRequestById();
				break;
			case 5:
				getMRDetails();
				break;
			case 6:
				getMdmDetails();
				break;
			default:
				return "-";
		}
	};
	if (data && data.form_id) {
		referenceDocumentTitle();
	}
	// const handleAnotherModalOk = () => {
	//   console.log('Another modal confirmed!');
	// };

	// const handleAnotherModalCancel = () => {
	//   console.log('Another modal canceled!');
	// };

	const userArray = [];
	if (data?.approvers) {
		const lastApprover = data.approvers[data.approvers.length - 1];

		if (lastApprover?.users) {
			userArray.push(...lastApprover.users);
		}
	}


	// Comment Condition Updated
	let canComment = 0;
	if (data) {
		if (data.status != "Approved" && data.status != "Return") {
			canComment = 1;
		} else {
			if (data.comment_status == 1) {
				canComment = 1;
			}
		}
	}
	// Comment Condition Updated


	const Isadmin = currentUser.roles.includes("admin");

	//  For hiding next hierarchy to the user
	let filteredApprovers = [];
	if (data) {
		const allApprovers = data.approvers;

		if (Array.isArray(allApprovers)) {
			filteredApprovers = allApprovers.map((approver) => ({
				...approver,
				users: approver.users
					? approver.users.filter((user) => user.status === "Processing")
					: [],
			}));

			console.log("filteredApprovers");
			console.log(filteredApprovers);
		} else {
			console.error("allApprovers is not defined or is not an array.");
		}
	}

	console.log("data");
	console.log(data);
	console.log("data");
	//  For hiding next hierarchy to the user
	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header icon={<FormOutlined />} title='Infra Change Request Details' />
				</Col>
			</Row>
			<Spin spinning={loading}>
				{data?.assigned_task?.assign_task_teams[0]?.members?.some(
					(m) => m.start_at && m.due_at
				) && (
					<TaskModal
						title='Tasks Logs'
						data_tasks={data.assigned_task.assign_task_teams[0].members}
						style={{ marginright: "0" }}
					/>
				)}
				{data?.task_status?.id !== null && (
					<FeedbackModal
						title='QA Feedback'
						formId={formId}
						assurable_id={id}
						style={{ marginright: "0" }}
					/>
				)}


				{/* PRINTABLE CARD */}
				{isPrintable && (
					<Card
						style={{
							minHeight: "100vh",
							marginLeft: "-200px",
							marginTop: "-50px",
							border: "none",
							padding: 24,
							background: "#fff",
						}}
						id='ppp'
					>
						<Row gutter={[24, 24]}>
							<Col span={4} style={{ textAlign: "center" }}>
								<img
									src={
										currentUser?.company?.logo
											? currentUser.company.logo.replace("/uploads", "")
											: "https://www.lucky-cement.com/wp-content/uploads/2017/02/lucky-logo.png"
									}
									alt='Logo'
									style={{ height: "40px", width: "auto", marginBottom: 16 }}
								/>
							</Col>
							<Col span={16} style={{ textAlign: "center" }}>
								<h2 style={{ marginBottom: 0 }}>
									<strong>Infra Change Request Form</strong>
								</h2>
							</Col>
							<Col span={4} style={{ textAlign: "center" }}>
								<h3> Internal </h3>
							</Col>
						</Row>
						<Row gutter={[24, 24]}>
							<Col span={24} style={{ textAlign: "center" }}>
								<div style={{ fontSize: 12, marginBottom: 16 }}>
									<b>Sequence No:</b> {data.sequence_no} &nbsp; | &nbsp;
									<b>Request Title:</b> {data.request_title} &nbsp; | &nbsp;
									<b>Status:</b> {data.status}
								</div>
							</Col>
							
						</Row>
						<Divider />
						<Row gutter={[16, 16]}>
							<Col xs={24} sm={12} md={8} lg={8} xl={8}>
								<b>Task Status:</b> <Tag>{data.task_status?.name}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={8} xl={8}>
								<b>Location:</b> <Tag>{data.location?.name}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={8} xl={8}>
								<b>Department:</b> <Tag>{data.department?.name}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={8} xl={8}>
								<b>Designation:</b> <Tag>{data.designation?.name}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={8} xl={8}>
								<b>Section:</b> <Tag>{data.section?.name}</Tag>
							</Col>
							<Col xs={24} sm={12} md={8} lg={8} xl={8}>
								<b>Required Date:</b>{" "}
								<Tag>{data.required_date ? dayjs(data.required_date).format('YYYY-MM-DD') : 'N/A'}</Tag>
							</Col>

							<Col xs={24}>
								<b>Affected Components:</b>{" "}
								{(() => {
									if (!data.affected_components) return <Tag>N/A</Tag>;
									let comps = data.affected_components;
									if (typeof comps === "string") {
										try { comps = JSON.parse(comps); } catch(e) {}
									}
									if (Array.isArray(comps)) {
										return comps.map((c, i) => <Tag key={i}>{c}</Tag>);
									}
									return <Tag>{String(comps)}</Tag>;
								})()}
							</Col>
						</Row>
						<Divider />
						
						<Card title="Change Request Specification & Justification" size="small" style={{ marginBottom: 16 }}>
							<p style={{ whiteSpace: 'pre-wrap' }}>{data.change_request_specification || 'N/A'}</p>
						</Card>

						<Row gutter={[16, 16]}>
							<Col span={12}>
								<Card title="Old Values" size="small">
									<p style={{ whiteSpace: 'pre-wrap' }}>{data.old_values || 'N/A'}</p>
								</Card>
							</Col>
							<Col span={12}>
								<Card title="Proposed New Values" size="small">
									<p style={{ whiteSpace: 'pre-wrap' }}>{data.proposed_new_values || 'N/A'}</p>
								</Card>
							</Col>
							
							<Col span={12}>
								<Card title="Change Tested?" size="small">
									<p style={{ whiteSpace: 'pre-wrap' }}>{data.change_tested || 'N/A'}</p>
								</Card>
							</Col>
							<Col span={12}>
								<Card title="Roll Back Scenario" size="small">
									<p style={{ whiteSpace: 'pre-wrap' }}>{data.roll_back_scenario || 'N/A'}</p>
								</Card>
							</Col>

							<Col span={24}>
								<Card title="Is Request Live and Functional?" size="small">
									<p style={{ whiteSpace: 'pre-wrap' }}>{data.request_live_and_functional || 'N/A'}</p>
								</Card>
							</Col>
						</Row>

						<Divider />
						<Card
							title={<span style={{ fontSize: "14px" }}>Created By</span>}
							className=''
							// style={{ border: "none"}}
							style={{
								border: "none",
								pageBreakBefore: "always",
								// margin: "-10px",
							}}
						>
							{data && data.created_by && (
								<>
									<Row gutter={[8, 8]} className=''>
										<Col xs={24} sm={8} md={8} lg={8} xl={8}>
											<span className='fs-10 '>
												<strong>Created At</strong>&nbsp;
											</span>
											<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
												&nbsp;{data.created_at}{" "}
											</Tag>
										</Col>

										<Col xs={24} sm={8} md={8} lg={8} xl={8}>
											<span className='fs-10 '>
												<strong>Name</strong>&nbsp;
											</span>
											<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
												&nbsp;{data.created_by.name}{" "}
											</Tag>
										</Col>

										<Col xs={24} sm={8} md={8} lg={8} xl={8}>
											<span className='fs-10 '>
												<strong>Department:</strong>&nbsp;
											</span>
											<Tag style={{ fontSize: "10px", minWidth: "65%" }}>
												&nbsp;{data.department.name}{" "}
											</Tag>
										</Col>
									</Row>
								</>
							)}
						</Card>
						<Card
							title={
								<span
									style={{
										fontSize: "14px",
										display: "block",
										textAlign: "center",
									}}
								>
									Approvers
								</span>
							}
							className=''
							style={{
								border: "none",
							}}
						>
							<Row gutter={[16, 16]}>
								<Col span={24}>
									<div style={{ overflowX: "auto", marginTop: 8 }}>
										<table
											style={{
												width: "100%",
												borderCollapse: "collapse",
												fontSize: 13,
											}}
										>
											<thead>
												<tr style={{ background: "#f5f5f5" }}>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Group
													</th>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Name
													</th>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Status
													</th>
													<th style={{ padding: 8, border: "1px solid #eee" }}>
														Action Performed At
													</th>
												</tr>
											</thead>
											<tbody>
												{Array.isArray(data?.approvers) &&
												data.approvers.length > 0 ? (
													data.approvers.flatMap((group) => {
														const respondedUsers = Array.isArray(group.users)
															? group.users.filter(
																	(approver) =>
																		approver.responded_by &&
																		approver.id &&
																		approver.responded_by.id === approver.id
															  )
															: [];

														if (respondedUsers.length === 0) {
															return [];
														}

														return respondedUsers.map((approver, uidx) => (
															<tr key={`${group.id}-${approver.id || uidx}`}>
																{uidx === 0 && (
																	<td
																		rowSpan={respondedUsers.length}
																		style={{
																			padding: 8,
																			border: "1px solid #eee",
																			fontWeight: "bold",
																			background: "#fafafa",
																			verticalAlign: "top",
																		}}
																	>
																		{group.name || "-"}
																	</td>
																)}
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.name || "-"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.status || "-"}
																</td>
																<td
																	style={{
																		padding: 8,
																		border: "1px solid #eee",
																	}}
																>
																	{approver.status_at || "-"}
																</td>
															</tr>
														));
													})
												) : (
													<tr>
														<td
															colSpan={4}
															style={{ padding: 8, textAlign: "center" }}
														>
															No approvers found.
														</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								</Col>
							</Row>
						</Card>

						<Divider />
					</Card>
				)}

				{/* WEB PAGE CARD */}
				<Card style={{ minHeight: "100vh" }} id='qqq'>
				{/*<Card style={{ minHeight: "100vh" }} className='print-area'>*/}
					<Row gutter={[24, 24]}>
						<Col lg={7} md={7} sm={7} xs={7}>
							<CreatedByComponent data={data} />
							<Button
								type='primary'
								onClick={handlePrintClick}
								style={{
									marginTop: "20px",
									marginBottom: "20px",
									width: "100%",
								}}
							>
								Print Document
							</Button>

							{data &&
								(data.status === "Pending" || data.status === "Approved") &&
								// Isadmin === true 
								hasEditPermission && (
									<AddApproversComponent data={data && data} formId={formId} />
								)}
							{/*<ApproversComponent approvers={data && filteredApprovers} />*/}
							<ApproversComponent approvers={data && data.approvers} />
						</Col>
						<Col lg={17} md={17} sm={17} xs={17}>
							<div>
								{data?.approved_disapproved === true && (
									<div
										style={{
											position: "sticky",
											top: 1,
											zIndex: 999,
											background: "#fff",
											padding: "5px",
											borderRadius: "4px",
										}}
									>
										<Spin spinning={loading}>
											<b className='fs-12-c'>Approval Request</b>
											<ApproveDisapproveComponent
												form={form}
												handleStatus={(values) => handleSubmit(values, false)}
												loading={loading}
												setStatus={setStatus}
												dataRecord={data}
												setSpecificReturnGroupId={setSpecificReturnGroupId}
											/>
										</Spin>
									</div>
								)}

								{data?.parallel_approved_disapproved === true && (
									<div
										style={{
											position: "sticky",
											top: data?.approved_disapproved ? "150px" : "1px",
											zIndex: 999,
											background: "#fff", // Add a background color
											padding: "5px", // Add padding for better visual separation
											borderRadius: "4px", // Optional: Add rounded corners
										}}
									>
										<Spin spinning={loading}>
											<b>Parallel Approval Request</b>
											<ApproveDisapproveComponent
												form={form}
												handleStatus={(values) => handleSubmit(values, true)}
												loading={loading}
												setStatus={setStatus}
												parallel={true}
												parallelUsers={
													data && data.parallel_approved_disapproved_users
												}
												setAssignedUserId={setAssignedUserId}
												reloadData={getInfraChangeRequestDetails}
												dataRecord={data}
												setSpecificReturnGroupId={setSpecificReturnGroupId}
											/>
										</Spin>
									</div>
								)}

								{data?.assigned_task_to_me === true && (
									<div
										style={{
											position: "sticky",
											top: "1px",
											zIndex: 999,
											background: "#fff", // Add a background color
											padding: "5px", // Add padding for better visual separation
											borderRadius: "4px", // Optional: Add rounded corners
										}}
									>
										<TaskStatus
											data={data}
											reloadData={getInfraChangeRequestDetails}
											formId={formId}
										/>
									</div>
								)}



										{data && (
											<>
											<Card title='Basic Information' className='mb-10'>
												<Row gutter={[16, 16]}>
													<Col xs={24} sm={12} md={8} lg={8} xl={8}>
														<p className='fs-12-c mb-10 bold'>Sequence No</p>
														<Tag>{data.sequence_no}</Tag>
													</Col>

													<Col xs={24} sm={12} md={8} lg={8} xl={8}>
														<p className='fs-12-c mb-10 bold'>Request Title</p>
														<Tag>{data.request_title}</Tag>
													</Col>

													{data.task_status?.name && (
														<Col xs={24} sm={12} md={8} lg={8} xl={8}>
															<p className='fs-12 mb-10 bold'>Task Status</p>
															<Tag>{data.task_status.name}</Tag>
														</Col>
													)}
												</Row>

												<Row gutter={[16, 16]} className='mt-10'>
													<Col xs={24} sm={12} md={8} lg={8} xl={8}>
														<p className='fs-12-c mb-10 bold'>Location</p>
														<Tag>{data.location?.name || "N/A"}</Tag>
													</Col>

													<Col xs={24} sm={12} md={8} lg={8} xl={8}>
														<p className='fs-12-c mb-10 bold'>Department</p>
														<Tag>{data.department?.name || "N/A"}</Tag>
													</Col>

													<Col xs={24} sm={12} md={8} lg={8} xl={8}>
														<p className='fs-12-c mb-10 bold'>Required Date</p>
														<Tag>{data.required_date ? dayjs(data.required_date).format('YYYY-MM-DD') : 'N/A'}</Tag>
													</Col>
												</Row>

												<Row gutter={[16, 16]} className='mt-10'>
													<Col xs={24}>
														<p className='fs-12-c mb-10 bold'>Affected Components</p>
														{(() => {
															if (!data.affected_components) return <Tag>N/A</Tag>;
															let comps = data.affected_components;
															if (typeof comps === "string") {
																try { comps = JSON.parse(comps); } catch(e) {}
															}
															if (Array.isArray(comps)) {
																return comps.map((c, i) => <Tag key={i}>{c}</Tag>);
															}
															return <Tag>{String(comps)}</Tag>;
														})()}
													</Col>
												</Row>
											</Card>
											
											<Card title="Change Request Specification & Justification" size="small" className='mb-10'>
												<p className="fs-12" style={{ whiteSpace: 'pre-wrap' }}>{data.change_request_specification || 'N/A'}</p>
											</Card>

											<Row gutter={[16, 16]} className='mb-10'>
												<Col span={12}>
													<Card title="Old Values" size="small" style={{ height: '100%' }}>
														<p className="fs-12" style={{ whiteSpace: 'pre-wrap' }}>{data.old_values || 'N/A'}</p>
													</Card>
												</Col>
												<Col span={12}>
													<Card title="Proposed New Values" size="small" style={{ height: '100%' }}>
														<p className="fs-12" style={{ whiteSpace: 'pre-wrap' }}>{data.proposed_new_values || 'N/A'}</p>
													</Card>
												</Col>
												
												<Col span={12}>
													<Card title="Change Tested?" size="small" style={{ height: '100%' }}>
														<p className="fs-12" style={{ whiteSpace: 'pre-wrap' }}>{data.change_tested || 'N/A'}</p>
													</Card>
												</Col>
												<Col span={12}>
													<Card title="Roll Back Scenario" size="small" style={{ height: '100%' }}>
														<p className="fs-12" style={{ whiteSpace: 'pre-wrap' }}>{data.roll_back_scenario || 'N/A'}</p>
													</Card>
												</Col>

												<Col span={24}>
													<Card title="Is Request Live and Functional?" size="small">
														<p className="fs-12" style={{ whiteSpace: 'pre-wrap' }}>{data.request_live_and_functional || 'N/A'}</p>
													</Card>
												</Col>
											</Row>
											</>
										)}
										{data && data.attachments && (
											<Card title='Other Attachments' className='mb-10'>
												<table
													style={{ width: "100%", borderCollapse: "collapse" }}
												>
													<thead>
														<tr>
															<th
																style={{
																	textAlign: "left",
																	padding: 8,
																	borderBottom: "1px solid #eee",
																}}
															>
																Title
															</th>
															<th
																style={{
																	textAlign: "left",
																	padding: 8,
																	borderBottom: "1px solid #eee",
																}}
															>
																Preview
															</th>
															<th
																style={{
																	textAlign: "left",
																	padding: 8,
																	borderBottom: "1px solid #eee",
																}}
															>
																Action
															</th>
														</tr>
													</thead>
													<tbody>
														{Array.isArray(data.attachments) &&
															data.attachments.map((attachment) => {
																const isImage = (filename) =>
																	/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(
																		filename
																	);
																const fileUrl = attachment.filename;
																const fileTitle =
																	getFileNameFromPath(
																		attachment.original_title
																	) || getFileNameFromPath(attachment.filename);
																return (
																	<tr key={attachment.id}>
																		<td
																			style={{
																				padding: 8,
																				verticalAlign: "middle",
																			}}
																		>
																			{fileTitle}
																		</td>
																		<td
																			style={{
																				padding: 8,
																				verticalAlign: "middle",
																			}}
																		>
																			{isImage(fileUrl) ? (
																				<a
																					href={fileUrl}
																					target='_blank'
																					rel='noopener noreferrer'
																					title='Preview image'
																				>
																					<img
																						src={fileUrl}
																						alt={fileTitle}
																						style={{
																							width: 40,
																							height: 40,
																							objectFit: "cover",
																							borderRadius: 4,
																							border: "1px solid #eee",
																							boxShadow:
																								"0 1px 4px rgba(0,0,0,0.08)",
																						}}
																					/>
																				</a>
																			) : (
																				<span
																					style={{
																						color: "#aaa",
																						fontSize: 12,
																					}}
																				>
																					No preview
																				</span>
																			)}
																		</td>
																		<td
																			style={{
																				padding: 8,
																				verticalAlign: "middle",
																			}}
																		>
																			<Button
																				size='small'
																				className='mb-10'
																				type='primary'
																				onClick={() => downloadFile(fileUrl)}
																			>
																				Download
																			</Button>
																		</td>
																	</tr>
																);
															})}
													</tbody>
												</table>
											</Card>
										)}

								{/* FETCH DATA CUSTOM FIELDS */}
								<ViewCustomFields customFields={data?.custom_fields} />

							</div>

							<CommentSystem
								id={id}
								form_id={formId}
								status={data && data.status}
								comment_status={data && canComment}
							/>
						</Col>
					</Row>
				</Card>
			</Spin>
		</DefaultLayout>
	);
};

export default InfraChangeRequestDetails;
